import { CloseOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import { COLOR_NEUTRAL_2, COLOR_NEUTRAL_5, COLOR_NEUTRAL_7 } from 'constants/colors';
import styled from 'styled-components';
import { Button, Input, Table } from 'UI';

export const FormContainer = styled(Form)`
  max-width: 100%;
`;

// min-width: 180px

export const TableHeaderTitle = styled.div`
  display: flex;
  width: content-fit;
`;

export const RowFormItem = styled(Form.Item)<{
  size?: number,
}>`
  margin: 0;
  min-width: ${({ size = 120 }) => `${size}px;`}
`;

export const RowSmallFormItem = styled(Form.Item)`
  margin: 0;
  min-width: 120px
`;

export const RowContentFitFormItem = styled(Form.Item)`
  margin: 0;
`;

export const GraftingOrderTable = styled(Table)`
  & .ant-table-thead > tr:nth-child(1) > th:nth-child(2) {
    background-color: ${COLOR_NEUTRAL_5};
  }
  & .ant-table-thead > tr:nth-child(1) > th:nth-child(4) {
    background-color: ${COLOR_NEUTRAL_5};
  }
`;

export const TableFooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const OrderPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  align-items: flex-end;
`;

export const AddRowButton = styled(Button)`
  width: fit-content;
  height: fit-content;
`;

export const RowInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const RemoveRowButton = styled(Button)`
  width: fit-content;
  background: transparent;
  border: 0;
  border-radius: 24px;
  box-shadow: none;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover,
  &:active,
  &:focus {
    background: transparent;
  }

  &.ant-btn > .anticon {
    line-height: 0;
  }
`;

export const RemoveRowIcon = styled(CloseOutlined)`
  font-size: 16px;
  color: ${COLOR_NEUTRAL_7};
  padding: 3px;

  &:hover {
    color: ${COLOR_NEUTRAL_2};
    background-color: ${COLOR_NEUTRAL_5};
    border-radius: 16px;
  }
`;

export const RowIndexLabel = styled.span`
  font-size: 16px;
  color: ${COLOR_NEUTRAL_7};
`;

export const NotesInput = styled(Input)`
  min-width: 300px;
`;
